import type { ImageProps } from '@mantine/core';
import { Image, useComputedColorScheme } from '@mantine/core';

export function LogoText(props: Omit<ImageProps, 'src'>) {
	const colorScheme = useComputedColorScheme('light', { getInitialValueInEffect: false });
	return <Image src={colorScheme === 'dark' ? '/logo-text-dark.svg' : '/logo-text.svg'} {...props} />;
}
